import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImage24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconImage24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19 5.5H5A1.5 1.5 0 0 0 3.5 7v5.609l4.083-2.732.423-.283.419.288 7.625 5.243 4.45-2.356V7A1.5 1.5 0 0 0 19 5.5m1.5 8.966-4.15 2.197-.4.212-.375-.257-7.58-5.212L3.5 14.413V17A1.5 1.5 0 0 0 5 18.5h14a1.5 1.5 0 0 0 1.5-1.5zM5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zm11 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImage24);
